var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tooltip", class: { "tooltip--small": _vm.size } },
    [
      _c("div", { staticClass: "shadowed" }, [
        _c(
          "div",
          { staticClass: "tooltip__header" },
          [
            _vm._t("default", function () {
              return [_vm._m(0)]
            }),
          ],
          2
        ),
        _vm._v(" "),
        !_vm.size
          ? _c("div", { staticClass: "tooltip__content" }, [
              _c("p", [
                _vm._v(
                  "You’ll need to raise your stakes to access this content."
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v("Contact your VIXIO Account Manager to upgrade."),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n          Find out more "),
      _c("a", { attrs: { href: "https://www.vixio.com/payments-platform" } }, [
        _vm._v("here"),
      ]),
      _vm._v(" or email "),
      _c("a", { attrs: { href: "mailto:clientvalue@vixio.com" } }, [
        _vm._v("clientvalue@vixio.com"),
      ]),
      _vm._v(" to activate this feature\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }